<div class="itineraries-form__image--title">{{ 'itineraries.detailImageTitleMobile' | translate }}</div>
<div class="itinerary-course-image__crop">
  <div
    (mousedown)="handleStageMouseDown($event)"
    (mousemove)="handleStageMouseMove($event)"
    (mouseup)="disableMove()"
    class="itinerary-course-image__crop--item"
    id="first"
    [ngClass]="{
      'itinerary-course-image__crop--grid': backgroundGrid
    }"
    [ngStyle]="{
      'background-image': bannerImg ? 'url(' + bannerImg + ')' : null,
      'background-position-x': position + 'px'
    }"
  ></div>
  <div class="itinerary-course-image__crop--info">
    <span
      class="glicon-icon-drag"
      [ngClass]="{
        'blue-text': backgroundGrid
      }"
      (click)="moveBackgroundGrid()"
    ></span>
    <span>{{ 'itineraries.detailCropImage' | translate }}</span>
  </div>
</div>
